// Bot de ayuda (E7d, 2026-08-31): POST /help/ask del núcleo lealify-base.
// El backend resuelve el vertical del tenant (t227 → letsmove) y responde solo
// con el manual de Let's Move. 200 -> { answer }. Errores: 400 corta / 429 rate
// limit / 502 falló el asistente (mensaje en body.error).
import { api } from './apiClient';

export const askHelpBot = async (question: string): Promise<string> => {
  const data = await api.post<{ answer?: string }>('/help/ask', { question });
  return data?.answer || '';
};

// Historial por usuario en el SERVIDOR (30-sep-2026, Karla): el mismo en compu y cel.
// Solo las preguntas del propio usuario desde su última «Nueva conversación».
export interface HelpHistoryRow { log_id: number; question: string; answer: string | null; ok: number; created_at: string }
export const getHelpHistory = async (): Promise<HelpHistoryRow[]> =>
  (await api.get<{ data: HelpHistoryRow[] }>('/help/history'))?.data || [];
export const clearHelpHistory = () => api.post<{ ok: boolean; hidden: number }>('/help/history/clear', {});
